import { EMPTY } from 'rxjs'
import { switchMap } from 'rxjs/operators'

import sessionExpiryAlert$ from '@apiEnabler/ob-common/lib/session-expiry-alert'

import { isStaffMember$ } from './staff'

const sessionExpiryAlertPbb$ = isStaffMember$.pipe(
  switchMap(isStaffMember => (isStaffMember ? EMPTY : sessionExpiryAlert$))
)

export default sessionExpiryAlertPbb$
